import CartItem from "@/Components/PosCart/CartItem";
import usePosOrderSelectedCartItemIndex from "@/shared/atoms/usePosOrderSelectedCartItemIndex";
import {
  useAddCartItem,
  useCart,
  useCartItemTotal,
  useDecreaseCartItem,
  useUpdateCartItemByIndex,
} from "@/shared/hooks/useCartHook";
import { useEffect, useRef } from "react";

const PosCartTop = () => {
  const [cart] = useCart();
  const [selectedCartItemIndex, setSelectedCartItemIndex] =
    usePosOrderSelectedCartItemIndex();
  const itemRefs = useRef<{ [key: number]: HTMLDivElement | null }>({});
  const getCartItemTotal = useCartItemTotal();
  const decreaseCartItem = useDecreaseCartItem();
  const addCartItem = useAddCartItem();
  const updateProductByIndex = useUpdateCartItemByIndex();

  const scrollToItem = (index: number) => {
    const itemRef = itemRefs.current[index];
    if (itemRef) {
      itemRef.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "nearest",
      });
    }
  };

  useEffect(() => {
    cart.length === 0 && setSelectedCartItemIndex(null);
  }, [cart, setSelectedCartItemIndex]);

  useEffect(() => {
    selectedCartItemIndex !== null && scrollToItem(selectedCartItemIndex);
  }, [selectedCartItemIndex, cart]);

  return (
    <div className="h-auto md:h-full overflow-y-auto flex-[1_0_auto] md:flex-[unset] mb-2">
      {cart.map((cartItem, index) => (
        <CartItem
          key={cartItem.item_id}
          cartItem={cartItem}
          index={index}
          ref={(el) => (itemRefs.current[index] = el)}
          onSelect={() =>
            setSelectedCartItemIndex((prev) => (prev === index ? null : index))
          }
          isSelected={selectedCartItemIndex === index}
          total={getCartItemTotal(cartItem)}
          onDelete={() => decreaseCartItem(cartItem)}
          onAdd={() => addCartItem({ ...cartItem, quantity: 1 })}
          onDeleteNote={() =>
            updateProductByIndex(index, { ...cartItem, note: "" })
          }
        />
      ))}
    </div>
  );
};

export default PosCartTop;
